// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* our variables */\n.add-index-btn[data-v-0185b125] {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n}\n.auto-mode[data-v-0185b125] {\n  color: #a1fda1 !important;\n}\n.manual-mode[data-v-0185b125] {\n  color: #ff8b8b !important;\n}\n.filter-icon[data-v-0185b125] {\n  margin-right: 10px;\n  /* Add spacing between icons */\n  cursor: pointer;\n  vertical-align: middle;\n  /* Vertically center the icons */\n}", ""]);
// Exports
module.exports = exports;
